import { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import * as Actions from 'flex/Actions';
import { selectors } from 'flex/Selectors';
import { useAppSelector } from 'flex/utils';

type SearchExamCategoryWithOrderChangeState = {
    exams: { title: string, uuid: string }[]
    isLoading: boolean
};

export const useSearchExamCategoryWithOrderChange = () => {
    const [state, setState] = useState<SearchExamCategoryWithOrderChangeState>({
        exams: [],
        isLoading: false,
    });

    const isControllableUser = useAppSelector(selectors.isControllableUser);
    const taoExamCategorySearchConnection = useAppSelector(state => state.taoExamCategorySearchConnection);
    const taoExamCategoryControlSimpleListConnection = useAppSelector(state => state.taoExamCategoryControlSimpleListConnection);

    const dispatch = useDispatch();

    useEffect(() => {
        const { meta, payload: { result } } = taoExamCategorySearchConnection;

        // 通信中でない === 画面遷移など意図しないタイミング
        if (!state.isLoading) return;

        switch (meta.status) {
            case Actions.statusEnum.SUCCESS: {
                setState({
                    exams: result
                        .items
                        .map(e => ({ title: e.title, uuid: e.uuid })),
                    isLoading: false,
                });

                return;
            }
            case Actions.statusEnum.FAILURE:
            case Actions.statusEnum.ERROR: {
                setState({
                    exams: [],
                    isLoading: false,
                });
                return;
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [taoExamCategorySearchConnection]);

    useEffect(() => {
        const { meta, payload: { result } } = taoExamCategoryControlSimpleListConnection;

        // 通信中でない === 画面遷移など意図しないタイミング
        if (!state.isLoading) return;

        switch (meta.status) {
            case Actions.statusEnum.SUCCESS: {
                setState({
                    exams: result
                        .items
                        .map(e => ({ title: e.title, uuid: e.uuid })),
                    isLoading: false,
                });

                return;
            }
            case Actions.statusEnum.FAILURE:
            case Actions.statusEnum.ERROR: {
                setState({
                    exams: [],
                    isLoading: false,
                });
                return;
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [taoExamCategoryControlSimpleListConnection]);


    const request = useCallback((
        requestType?: 'control' | 'default'
    ) => {

        // 実装時は管理者だけでの利用を想定しているが、一応残しておく
        if(isControllableUser || requestType === 'control') {
            const searchAction = Actions.http.connection.tao.examControlCategory.simpleList;
            dispatch(searchAction({ page_size: 1000 }, 1, ''));
        } else {
            const searchAction = Actions.http.connection.tao.examCategory.search;
            dispatch(searchAction({ page_size: 500 }, 1, ''));
        }

        setState(state => ({
            ...state,
            isLoading: true,
        }));

    }, [dispatch, isControllableUser]);

    const reset = useCallback(() => {
        setState({
            exams: [],
            isLoading: false,
        });
    }, []);

    return [state, request, reset] as const;
};
